"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeTimeFunction = void 0;
const tslib_1 = require("tslib");
class IkeTimeFunction {
    /**
     * Execute a function and measure how long it took.
     * @param func the function to measure execution time of
     */
    static timeFunction(func) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const startTime = Date.now();
            yield func();
            return Date.now() - startTime;
        });
    }
}
exports.IkeTimeFunction = IkeTimeFunction;
//# sourceMappingURL=time.function.js.map